module.exports = __webpack_public_path__ + "img/newcastle.f64bf146.png";